import { Box, Drawer, useMediaQuery, useTheme } from '@mui/material';
import Sidebar from './Sidebar';
import Header from './DashboardHeader';
import { ReactNode, useEffect, useState } from 'react';
import { useLocation, matchPath } from 'react-router-dom';

interface Props {
  children: ReactNode;
}

const pathToTitleMap: Record<string, string> = {
  '/dashboard': 'Propiedades',
  '/checkout/:id': 'Paga tu alquiler',
  '/detalle-pago/:uuid/:paymentUuid': 'Detalle del pago',
  '/detalle-inmueble/:uuid': 'Detalle de propiedad',
  '/checkout-respuesta/:uuid': 'Respuesta del pago',
  '/pagos': 'Pagos',
  '/referidos': 'Referidos',
  '/ajustes': 'Ajustes',
  '/calcular': 'Calcular alquiler',
};

export default function Layout({ children }: Props) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const getTitleFromPath = (pathname: string) => {
    for (const pattern in pathToTitleMap) {
      if (matchPath({ path: pattern, end: true }, pathname)) {
        return pathToTitleMap[pattern];
      }
    }
    return pathToTitleMap['*'];
  };

  const [title, setTitle] = useState(() => getTitleFromPath(location.pathname));

  useEffect(() => {
    setTitle(getTitleFromPath(location.pathname));
  }, [location.pathname]);

  const toggleDrawer = () => setMobileOpen(!mobileOpen);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', backgroundColor: '#f3f3f3' }}>
      
      {/* HEADER ARRIBA */}
      <Header title={title} onMenuClick={toggleDrawer} />

      {/* CONTENEDOR: SIDEBAR IZQUIERDA + CONTENIDO */}
      <Box sx={{ display: 'flex', flexGrow: 1, overflow: 'hidden' }}>

        {/* SIDEBAR SOLO ESCRITORIO */}
        {!isMobile && (
          <Box sx={{ height: '100%' }}>
            <Sidebar onSelect={(label) => setTitle(label)} />
          </Box>
        )}

        {/* DRAWER PARA MOBILE */}
        {isMobile && (
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onClose={toggleDrawer}
            ModalProps={{ keepMounted: true }}
          >
            <Sidebar
              onSelect={(label) => {
                setTitle(label);
                toggleDrawer();
              }}
            />
          </Drawer>
        )}

        {/* CONTENIDO */}
        <Box
          sx={{
            marginX: 1,
            flexGrow: 1,
            overflowY: 'auto',
            height: '99%',
            width: '90%',
            backgroundColor: '#fff',
            border: '1px solid #ececec',
            borderRadius: '18px', // ← curva SOLO arriba a la izquierda
            
          }}
        >
          
          {children}
        </Box>

      </Box>
    </Box>
  );
}
